import React from 'react';
import './WeatherNav.css';
import Isvg from 'react-inlinesvg';

import { formatTemperature } from '../../utils/weather';


const propTypes = {
  days: React.PropTypes.arrayOf(React.PropTypes.shape({
    dayName: React.PropTypes.string.isRequired,
    icon: React.PropTypes.string.isRequired,
    id: React.PropTypes.number.isRequired,
    isActive: React.PropTypes.bool,
    temperatureMax: React.PropTypes.number.isRequired,
    temperatureMin: React.PropTypes.number.isRequired,
  })).isRequired,
  onChange: React.PropTypes.func.isRequired
}

const WeatherNav = props => (
  <div className='weather-nav'>
    {props.days.map((day, index) => (
      <button
        key={day.id}
        type='button'
        className={`weather-nav__btn ${day.isActive && 'weather-nav__btn--active'}`}
        onClick={() => {
          props.onChange(day.index)
        }}>
        <span className='weather-nav__btn-day'>{day.dayName}</span>
        <span className='weather-nav__btn-icon'>
          <Isvg
            src={`${process.env.PUBLIC_URL}/icons/weather/${day.icon}.svg`}
            cacheGetRequests={true} />
        </span>
        <span className='weather-nav__btn-temp'>
          {formatTemperature(day.temperatureMax)} / {formatTemperature(day.temperatureMin)}
        </span>
      </button>
    ))}
  </div>
)

WeatherNav.propTypes = propTypes;

export default WeatherNav;



// WEBPACK FOOTER //
// ./src/components/WeatherNav/WeatherNav.js